module.exports = __webpack_public_path__ + "static/media/1003023.7d4bb98e.jpg";